export default __webpack_public_path__ + "assets/static/data/app.model.d7c9bf4db051ae436e7bd036715b07e1.json";